<template>
  <div class="el-input">
    <div style="width:10em; float: left" ><el-input :value="amount" @input="changeAmount($event)" /></div>
    <el-select :value="unit" value-key="key" :size="size" @input="change($event)" style="width:10em">
      <el-option label="条" value="" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      amount: 1,
      unit: ''
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    changeAmount: function (val) {
      this.amount = val
      this.$emit('input', '' + this.amount + this.unit)
    },
    change: function (val) {
      this.unit = val
      this.$emit('input', '' + this.amount + this.unit)
    }
  },
  mounted () {
    let data = /([0-9]+)/.exec(this.value)
    if (data) {
      this.amount = data[1]
      this.unit = ''
    }
    this.$emit('input', '' + this.amount + this.unit)
  },
  watch: {
    value (val) {
      let data = /^([0-9]+)/.exec(val)
      if (data) {
        this.amount = data[1]
        this.unit = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/MessageUnitSelect.vue